module.exports = __webpack_public_path__ + "static/media/duck-rocket.78bba211.gif";